import { useContext, useEffect } from 'react';

import PageContext from '@/Providers/PageContextProvider/PageContext';

// The VibeHub experience owns its palette. Provider configuration must not
// restore Logto's default purple after the stylesheet has loaded.
const brandColors = {
  '--color-brand-default': '#b8ff28',
  '--color-brand-hover': '#aaf21a',
  '--color-brand-pressed': '#9edb20',
  '--color-brand-loading': '#b8ff28',
  '--color-overlay-brand-focused': 'rgba(184, 255, 40, 0.35)',
  '--color-overlay-brand-hover': 'rgba(184, 255, 40, 0.12)',
  '--color-overlay-brand-pressed': 'rgba(184, 255, 40, 0.2)',
  '--color-type-link': '#0d171f',
};

const useColorTheme = () => {
  const { theme } = useContext(PageContext);
  useEffect(() => {
    for (const [key, value] of Object.entries(brandColors)) {
      document.body.style.setProperty(key, value);
    }
  }, [theme]);
};

export default useColorTheme;
